export default __webpack_public_path__ + "static/media/Mvision.79a2d49c.svg";